import React from 'react'

function IncludeFileData (props) {
  return (
    <section dangerouslySetInnerHTML={{__html: props.html}}/>
  )
}

export default IncludeFileData